<template>
    <div class="wrapFczs">
        <!--标题-->
        <div class="headerF">
            分类：
            <span
                @click="changeType(index, item)"
                v-for="(item, index) in titleList"
                :key="index"
                :class="[
                    'headerSpanF',
                    activeTitle == index ? 'tab-active' : ''
                ]"
                >{{ item.navigationName }}</span
            >
        </div>
        <!--内容-->
        <div class="contentF">
            <div
                v-for="(item, index) in listData.list"
                @click="goDetail(item, activeItem.navigationName)"
                :key="index"
                class="boxF"
            >
                <div class="imgF scale-box">
                    <img :src="item.image" :alt="item.title" />
                </div>
                <div class="titleF">
                    {{
                        item.title.length > 30
                            ? item.title.substring(0, 30) + "..."
                            : item.title
                    }}
                </div>
                <div class="timeF">
                    <span>{{
                        item.creaTime && item.creaTime.time | dateFormat
                    }}</span>
                    <span class="viewF">浏览量:{{ item.popularity }}</span>
                </div>
            </div>
        </div>
        <pagebreak
            :totalPage="listData.totalPage"
            @changePage="changePage"
        ></pagebreak>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "xxxmy",
    data() {
        return {
            activeItem: {
                id: 9,
                navigationName: "全部"
            },
            listData: {
                list: [],
                totalPage: 0,
                current: 1
            },
            activeTitle: 0,
            titleList: []
        };
    },
    created() {
        this.getTitle();
        this.getListData();
    },
    methods: {
        changeType(index, item) {
            this.activeTitle = index;
            this.activeItem = item;
            this.getListData(item.id);
        },
        getTitle() {
            // navlist
            if (localStorage.getItem("navlist")) {
                try {
                    JSON.parse(localStorage.getItem("navlist")).forEach(
                        item => {
                            if (item.id == 9) {
                                this.titleList = item.subList;
                                this.titleList.unshift({
                                    id: 9,
                                    navigationName: "全部"
                                });
                            }
                        }
                    );
                } catch (e) {}
            }
            this.$ajax({
                url: "homePage/myNavigation",
                method: "post",
                success: res => {
                    if (res.code == 200) {
                        res.message.forEach(item => {
                            if (item.id == 9) {
                                this.titleList = item.subList;
                                this.titleList.unshift({
                                    id: 9,
                                    navigationName: "全部"
                                });
                            }
                        });
                    }
                },
                error: () => {}
            });
        },
        changePage(index) {
            this.getListData(this.type, index);
        },
        getListData(type = 9, page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: this.activeItem.id,
                    current: page
                },
                success: res => {
                    if (res.code == 200) {
                        this.listData.list = res.message.records;
                        this.listData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                },
                error: res => {
                    console.log(res);
                }
            });
        },
        goDetail(item, titleTwo = "") {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: item.id,
                    t1: "学习型密云",
                    t2: titleTwo ? titleTwo : ""
                }
            });
        }
    }
};
</script>
<style scoped="scoped">
.wrapFczs {
    width: 1000px;
    overflow: hidden;
    margin: 30px auto;
    min-height: 500px;
}

.contentF {
    width: 1000px;
    min-height: 500px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    cursor: default;
}

.headerSpanF {
    margin-right: 30px;
    cursor: pointer;
}

.boxF {
    width: 242px;
    display: inline-block;
    margin-top: 20px;
    margin-right: 10px;
    box-sizing: border-box;
}
.boxF:nth-child(4n) {
    margin-right: 0;
}

.imgF {
    width: 100%;
    height: 164.9px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
}
.imgF img {
    width: 100%;
    min-height: 100%;
    transition: all ease 0.2s;
}

.imgF:hover {
    border: 1px solid #999;
}

.titleF {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.timeF {
    color: gray;
    font-size: 14px;
    padding: 0 5px 0 0;
}

.viewF {
    float: right;
}

.tab-active {
    color: #6ac0e8;
}
</style>


// WEBPACK FOOTER //
// src/components/xxxmy/xxxmy.vue